/**
 * A chave do `<RouterView>` de `app.vue` — quem decide se trocar de URL
 * REMONTA a tela ou reaproveita a instância que já está lá.
 *
 * ★ POR QUE ISTO EXISTE (18/09/2026)
 *
 * A chave sempre foi `$route.fullPath`: qualquer mudança de URL (path, param
 * ou query) destrói o componente de rota e monta outro. Para o app inteiro isso
 * é o certo — cada tela nasce limpa.
 *
 * Na tela imersiva do chat (`/home-ia`, `/home-ia/c/<uuid>`) o mesmo
 * comportamento é destrutivo, e não por lentidão: a conversa GANHA id no meio
 * do primeiro envio (o backend o devolve no `start` do SSE, ou na resposta do
 * `POST /runs`), e é nesse instante que a URL passa a apontar para ela. Com a
 * chave por caminho, o `<ViewChat>` seria destruído com o stream aberto e a
 * resposta que estava chegando sumiria — o consultor manda a primeira mensagem
 * e não recebe nada.
 *
 * ★ OPT-IN, e isso é a decisão: a rota DECLARA `meta.chaveDeMontagem` quando
 * quer sobreviver à própria mudança de URL. Quem não declara segue com
 * `fullPath`, byte a byte como hoje — um comportamento cross-cutting não muda
 * para todo mundo por causa de uma tela. Mesmo padrão declarativo de
 * `meta.allowMobile`, que substituiu em `app.vue` um `if` de nome de rota
 * hardcoded (ver o comentário de `routeAllowsMobile`).
 *
 * ⚠️ Duas rotas só reaproveitam a instância se declararem o MESMO valor — é o
 * valor que é a chave, não o nome da rota. `/home-ia` e `/home-ia/c/<uuid>` são
 * rotas de nomes diferentes de propósito (a segunda tem param), e é por
 * declararem a mesma chave que trocar de conversa não remonta nada.
 *
 * ⚠️ E A CHAVE IGUAL NÃO BASTA (medido em 19/09/2026): as rotas têm de dividir
 * o MESMO loader. Cada `lazyLoadView(import(...))` cria a própria fábrica
 * assíncrona, e no 1º uso dela o Vue renderiza um placeholder (comentário) por
 * um tick — `sameVnode` falha contra a tela montada e ela é destruída mesmo
 * com a chave igual. Ver `carregarTelaImersiva` em `aawz-intelligence/routes.js`.
 *
 * @param {Object} route rota atual (`this.$route`)
 * @returns {string} a chave de montagem
 */
export function chaveDeMontagemDaRota(route) {
  if (!route) return ''
  const declarada = route.meta && route.meta.chaveDeMontagem
  return declarada || route.fullPath
}
